export function getHeaderDesc(type, i18n) {
  const descriptions = {
    Location: {
      raiseHeader: i18n.getString('BidAdjustmentOpt_RaiseBidHeader'),
      raiseSubtitle: i18n.getString('BidAdjustmentOpt_Location_RaiseBidSubTitle'),
      lowerHeader: i18n.getString('BidAdjustmentOpt_LowerBidHeader'),
      lowerSubtitle: i18n.getString('BidAdjustmentOpt_Location_LowerBidSubTitle'),
    },
    Scheduling: {
      raiseHeader: i18n.getString('BidAdjustmentOpt_RaiseBidHeader'),
      raiseSubtitle: i18n.getString('BidAdjustmentOpt_Scheduling_RaiseBidSubTitle'),
      lowerHeader: i18n.getString('BidAdjustmentOpt_LowerBidHeader'),
      lowerSubtitle: i18n.getString('BidAdjustmentOpt_Scheduling_LowerBidSubTitle'),
    },
    Keyword: {
      raiseHeader: i18n.getString('BidAdjustmentOpt_Keyword_RaiseBidHeader'),
      raiseSubtitle: '',
      lowerHeader: i18n.getString('BidAdjustmentOpt_Keyword_LowerBidHeader'),
      lowerSubtitle: '',
    },
  };

  return descriptions[type];
}

export function isRaiseOpportunity(opportunity, type) {
  switch (type) {
    case 'Keyword':
      return opportunity.suggestedBid > opportunity.currentBid;
    case 'Scheduling':
    case 'Location':
      return opportunity.bidMultiplier > opportunity.currentBidMultiplier;
    default:
      throw new Error(`Please implement the check code for the type: ${type}`);
  }
}
